/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaOutlet
 */
export interface PrtimesMediaOutlet {
    /**
     * メディアID
     * @type {number}
     * @memberof PrtimesMediaOutlet
     */
    mediaOutletId: number;
    /**
     * メディア種類名
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    mediaTypeName: string;
    /**
     * メディア名
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    mediaName: string;
    /**
     * 媒体概要
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    mediaOverview: string;
    /**
     * 発行部数/PV
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    reach: string;
    /**
     * 企業名
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    companyName: string;
    /**
     * 所属部署
     * @type {string}
     * @memberof PrtimesMediaOutlet
     */
    department: string;
    /**
     * 配信手段
     * @type {Array<string>}
     * @memberof PrtimesMediaOutlet
     */
    deliveryMethods: Array<PrtimesMediaOutletDeliveryMethodsEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PrtimesMediaOutletDeliveryMethodsEnum {
    Email = 'email',
    Fax = 'fax'
}


/**
 * Check if a given object implements the PrtimesMediaOutlet interface.
 */
export function instanceOfPrtimesMediaOutlet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mediaOutletId" in value;
    isInstance = isInstance && "mediaTypeName" in value;
    isInstance = isInstance && "mediaName" in value;
    isInstance = isInstance && "mediaOverview" in value;
    isInstance = isInstance && "reach" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "deliveryMethods" in value;

    return isInstance;
}

export function PrtimesMediaOutletFromJSON(json: any): PrtimesMediaOutlet {
    return PrtimesMediaOutletFromJSONTyped(json, false);
}

export function PrtimesMediaOutletFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaOutlet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaOutletId': json['media_outlet_id'],
        'mediaTypeName': json['media_type_name'],
        'mediaName': json['media_name'],
        'mediaOverview': json['media_overview'],
        'reach': json['reach'],
        'companyName': json['company_name'],
        'department': json['department'],
        'deliveryMethods': json['delivery_methods'],
    };
}

export function PrtimesMediaOutletToJSON(value?: PrtimesMediaOutlet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_outlet_id': value.mediaOutletId,
        'media_type_name': value.mediaTypeName,
        'media_name': value.mediaName,
        'media_overview': value.mediaOverview,
        'reach': value.reach,
        'company_name': value.companyName,
        'department': value.department,
        'delivery_methods': value.deliveryMethods,
    };
}

